var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100%"}},[_c('v-slide-x-transition',{attrs:{"leave-absolute":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }